export type LinkableFee = {
    id: string;
    shortCode: string | null;
    type: string;
    isDonation: boolean;
};

export const buildFeeLink = (fee: LinkableFee | undefined, origin: string): string | null => {
    if (fee?.type !== "optional" || fee.isDonation) {
        return null;
    }

    const link = new URL(origin);

    if (fee.shortCode) {
        link.pathname = `/f/${fee.shortCode}`;
        return link.href;
    }

    link.hash = `feeId=${encodeURIComponent(fee.id)}`;
    return link.href;
};
